  document.addEventListener("DOMContentLoaded", function () {

    // traduction des titres de recettes RecipeKit
    const isEnglish = window.location.pathname.includes("/en/");
    const isArticleDIY = document.querySelector(".article-template.recette-diy");
  
    if (!isEnglish || !isArticleDIY) return;
  
    // Traduction des titres de .rk_column
    const rkColumnTranslations = {
      "Catégorie": "Category",
      "Quantité": "Quantity",
      "Temps de préparation": "Preparation time"
    };
  
    document.querySelectorAll(".rk_column h2.rk_meta").forEach(h2 => {
      const text = h2.textContent.trim();
      if (rkColumnTranslations[text]) {
        h2.textContent = rkColumnTranslations[text];
      }
    });
  
    // Traduction des h2.rk_column_heading span
    const headingTranslations = {
      "Ingrédients": "Ingredients",
      "Étapes": "Steps",
      "Comment utiliser la recette": "How to use the recipe"
    };
  
    document.querySelectorAll("h2.rk_column_heading span").forEach(span => {
      const text = span.textContent.trim();
      if (headingTranslations[text]) {
        span.textContent = headingTranslations[text];
      }
    });
  
    // Traduction des boutons et textes d'action
    const atcText = document.querySelector(".rk_atc_text");
    if (atcText && atcText.textContent.trim() === "Ajouter au panier") {
      atcText.textContent = "Add to cart";
    }
  
    setTimeout(() => {
      const atcAll = document.querySelector(".rk_atc_all");
      if (atcAll && atcAll.textContent.trim() === "Tout ajouter au panier") {
        atcAll.textContent = "Add all to cart";
      }
    }, 1500); // Attends 500 ms pour laisser le temps au bouton d'apparaître
  
    const cartBtn = document.querySelector("#rk_cart_btn");
    if (cartBtn) {
      cartBtn.textContent = cartBtn.textContent.replace("Voir le panier", "View cart");
    }
  
    const checkoutBtn = document.querySelector("#rk_checkout_btn span");
    if (checkoutBtn && checkoutBtn.textContent.trim() === "Accéder au paiement") {
      checkoutBtn.textContent = "Checkout";
    }



    // easiware
    (function() {
      var __easiboxId = window.__easiboxId = 200;
      var __easiboxHost = window.__easiboxHost ="https://app.easiware.com";
      var u_js = __easiboxHost+'/easibox.js';
      var d=document,js=d.createElement('script');
      js.async=true; js.src=u_js; d.body.append(js);
    })();
    

    // scroll en douceur vers une ancre #id_section )
    const defaultOffset = 50; // possibilité d'indiquer data-offset dans le lien

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href").substring(1);

        if (!targetId) {
          e.preventDefault();
          return;
        }

        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          e.preventDefault();

          const customOffset = parseInt(this.dataset.offset || defaultOffset, 10);

          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - customOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    });
  
    
  });

